/* import __COLOCATED_TEMPLATE__ from './reviewable-created-by.hbs'; */
import Component, { setComponentTemplate } from "@ember/component";
import TEMPLATE from "./reviewable-created-by.hbs";
export default setComponentTemplate(TEMPLATE, Component.extend({}));